export default {
  name: 'admin',
  path: 'admin',
  component: () => import('@/views/app/admin/Admin.vue'),
  meta: {
    requiresAuth: true
  },
  children: [
    {
      name: 'admin-facilities',
      path: 'facilities',
      component: () => import('@/views/app/admin/pages/Facilities.vue'),
      meta: {
        zuntaAdminOnly: true,
        requireAuth: true
      }
    },
    {
      name: 'admin-chains',
      path: 'chains',
      component: () => import('@/views/app/admin/pages/Chains.vue'),
      meta: {
        zuntaAdminOnly: true,
        requireAuth: true
      }
    },
    {
      name: 'admin-create-chain',
      path: 'chains/new',
      component: () => import('@/views/app/admin/pages/CreateChain.vue'),
      meta: {
        zuntaAdminOnly: true,
        requireAuth: true
      }
    },
    {
      name: 'admin-update-chain',
      path: 'chains/update-chain/:id',
      component: () => import('@/views/app/admin/pages/CreateChain.vue'),
      meta: {
        zuntaAdminOnly: true,
        requireAuth: true
      }
    },
    {
      name: 'admin-chain-page',
      path: 'chains/:id',
      component: () => import('@/views/app/admin/pages/chain-page/ChainPage.vue'),
      meta: {
        zuntaAdminOnly: true,
        requireAuth: true
      }
    },
    {
      name: 'admin-chain-page-todo',
      path: 'chains/:id/todos/:todo',
      component: () => import('@/views/app/admin/pages/chain-page/ChainPage.vue'),
      meta: {
        zuntaAdminOnly: true,
        requireAuth: true
      }
    },
    {
      name: 'admin-users',
      path: 'users',
      component: () => import('@/views/app/admin/pages/Users.vue'),
      meta: {
        zuntaAdminOnly: true,
        requireAuth: true
      }
    },
    {
      name: 'uikit',
      path: 'uikit',
      component: () => import('@/views/app/admin/pages/UiKit.vue'),
      meta: {
        zuntaAdminOnly: true,
        requireAuth: true
      }
    },
    {
      name: 'admin-facilities-users',
      path: 'facilities-users',
      component: () => import('@/views/app/admin/pages/FacilitiesUsers.vue'),
      meta: {
        zuntaAdminOnly: true,
        requireAuth: true
      }
    },
    {
      name: 'admin-facilities-users-page',
      path: 'facilities-users/:id',
      component: () => import('@/views/app/admin/pages/user-page/UserPage.vue'),
      meta: {
        zuntaAdminOnly: true,
        requireAuth: true
      }
    },
    {
      name: 'admin-facilities-users-page-todo',
      path: 'facilities-users/:id/todos/:todo',
      component: () => import('@/views/app/admin/pages/user-page/UserPage.vue'),
      meta: {
        zuntaAdminOnly: true,
        requireAuth: true
      }
    },
    {
      path: 'facilities-users/user/:id',
      name: 'admin-users-edit',
      meta: {
        zuntaAdminOnly: true,
        requireAuth: true
      },
      component: () => import('@/views/app/management/users/UserEdit.vue')
    },
    {
      path: 'todo',
      name: 'admin-todo',
      meta: {
        zuntaAdminOnly: true,
        requireAuth: true
      },
      component: () => import('@/views/app/admin/pages/ToDo.vue')
    },
    {
      path: 'dashboard',
      name: 'admin-dashboard',
      meta: {
        zuntaAdminOnly: true,
        requireAuth: true
      },
      component: () => import('@/views/app/admin/pages/dashboard/Dashboard.vue')
    },
    {
      path: 'billing',
      name: 'admin-billing',
      meta: {
        zuntaAdminOnly: true,
        requireAuth: true
      },
      component: () => import('@/views/app/admin/pages/billing/BillingPage.vue'),
      redirect: { name: 'admin-billing-batches' },
      children: [
        {
          path: 'batches/:user?',
          name: 'admin-billing-batches',
          meta: {
            zuntaAdminOnly: true,
            requireAuth: true
          },
          component: () => import('@/views/app/admin/pages/billing/tabs/BillingPageTab.vue')
        },
        {
          path: 'invoices/:user?',
          name: 'admin-billing-invoices',
          meta: {
            zuntaAdminOnly: true,
            requireAuth: true
          },
          component: () => import('@/views/app/admin/pages/billing/tabs/InvoicePageTab.vue')
        }
      ]
    },
    {
      path: 'billing/:batch',
      name: 'admin-billing-details',
      meta: {
        zuntaAdminOnly: true,
        requireAuth: true
      },
      component: () => import('@/views/app/admin/pages/billing/BillingDetailsPage.vue'),
      children: [
        {
          path: 'commissions/:user?',
          name: 'admin-billing-details-commissions',
          meta: {
            zuntaAdminOnly: true,
            requireAuth: true
          },
          component: () => import('@/views/app/admin/pages/billing/pages/CommissionsPage.vue')
        },
        {
          path: 'invoices/:user?',
          name: 'admin-billing-details-invoices',
          meta: {
            zuntaAdminOnly: true,
            requireAuth: true
          },
          component: () => import('@/views/app/admin/pages/billing/pages/InvoicePage.vue')
        },
        {
          path: 'settings',
          name: 'admin-billing-details-settings',
          meta: {
            zuntaAdminOnly: true,
            requireAuth: true
          },
          component: () => import('@/views/app/admin/pages/billing/pages/SettingsPage.vue')
        }
      ]
    },
    {
      path: 'payments',
      name: 'admin-payments',
      meta: {
        zuntaAdminOnly: true,
        requireAuth: true
      },
      component: () => import('@/views/app/admin/pages/payments/Payments.vue')
    },
    {
      path: 'uploads',
      name: 'admin-uploads',
      meta: {
        zuntaAdminOnly: true,
        requireAuth: true,
        dataEntryUser: true
      },
      component: () => import('@/views/app/admin/pages/uploads/Uploads.vue')
    },
    {
      path: 'pcc-deposits',
      name: 'admin-pcc-deposits',
      meta: {
        zuntaAdminOnly: true,
        requireAuth: true,
        dataEntryUser: true
      },
      component: () => import('@/views/app/admin/pages/pcc-deposits/PccDeposits.vue')
    },
    {
      path: 'eligibility-tasks',
      name: 'admin-eligibility-tasks',
      meta: {
        zuntaAdminOnly: true,
        requireAuth: true,
        dataEntryUser: true
      },
      component: () => import('@/views/app/admin/pages/eligibility-tasks/EligibilityTasks.vue')
    },
    {
      path: 'milestones',
      name: 'admin-milestones',
      meta: {
        zuntaAdminOnly: true,
        requireAuth: true
      },
      component: () => import('@/views/app/admin/pages/milestones/Milestones.vue'),
      children: [
        {
          path: 'chains',
          name: 'admin-chains-milestones',
          meta: {
            zuntaAdminOnly: true,
            requireAuth: true
          },
          component: () => import('@/views/app/admin/pages/milestones/pages/ChainsMilestones.vue')
        },
        {
          path: 'users',
          name: 'admin-users-milestones',
          meta: {
            zuntaAdminOnly: true,
            requireAuth: true
          },
          component: () => import('@/views/app/admin/pages/milestones/pages/UsersMilestones.vue')
        }
      ]
    }
  ]
}
